/**
 * Tabellen-Hinweise (Punktabzug, Wertungen, …) nach fmpSeasonId.
 * Nur Saisons eintragen, bei denen wirklich Text erscheinen soll.
 */
const RANKING_HINTS_BY_SEASON_ID = {
    1544: [
        'Abzug von 4 Pluspunkten SV Werder Bremen wegen Verstoß gegen die Lizenzierungsrichtlinien.',
        'Das Spiel Lintfort - Regensburg wurde aufgrund des Einsatzes einer nicht spielberechtigten Spielerin mit 0:2 Punkten und 0:0 Toren gewertet.',
    ].join('\n\n'),
    1709: 'Die Spiele Blomberg - Oldenburg (21.03.26) und Zwickau - Oldenburg (25.03.26) wurden aufgrund des Einsatzes einer nicht spielberechtigten Spielerin je mit 0:2 Punkten und 0:0 Toren gegen den VfL Oldenburg gewertet.',
    1710: 'Aufgrund des Rückzugs der HB Ludwigsburg sowie lediglich einem sportlich qualifizierten, potentiellen Aufsteiger aus den 3. Ligen (SV Todesfelde), verbleiben die Teams auf den Plätzen 14 bis 16 in der 2. Alsco HBF.',
};

/**
 * @param {number|string|null|undefined} fmpSeasonId
 * @returns {string|null}
 */
export function rankingHintForSeason(fmpSeasonId) {
    if (fmpSeasonId == null || fmpSeasonId === '') {
        return null;
    }
    const id = Number(fmpSeasonId);
    if (Number.isNaN(id)) {
        return null;
    }
    const text = RANKING_HINTS_BY_SEASON_ID[id];
    return typeof text === 'string' && text.length ? text : null;
}

/**
 * @param {number|string|null|undefined} fmpSeasonId
 * @returns {boolean}
 */
export function hasRankingHint(fmpSeasonId) {
    return rankingHintForSeason(fmpSeasonId) != null;
}
